
const $ = selector => [...document.querySelectorAll(selector)]

let store = []

export const trackEvent = (event, data) => store.push({ event, ...data })

export default ({
  dataLayerName,
  dataTargets,
} = {
  dataLayerName: 'dataLayer',
  dataTargets: [],
}) => {

  if (!window[dataLayerName]) {
    window[dataLayerName] = []
  }

  store = window[dataLayerName]

  dataTargets.forEach(({ elementName, selector }) => {
    $(selector).forEach((el) => {
      el.setAttribute('data-t-element', elementName);
    })
  })
}
